import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import type { GroupDetail } from '../../../../types'
import { SelectField, TextField } from '../../components/form'
import type { TransactionFilters } from '../../hooks/useTransactions'

export type HistoryFiltersProps = {
    group: GroupDetail
    filters: TransactionFilters
    onChange: (filters: TransactionFilters) => void
    onReset: () => void
}

export function HistoryFilters({ group, filters, onChange, onReset }: HistoryFiltersProps) {
    const set = <TKey extends keyof TransactionFilters>(key: TKey, value: TransactionFilters[TKey]) => {
        onChange({ ...filters, [key]: value === '' ? undefined : value })
    }

    return (
        <Card className="mb-3">
            <Card.Body>
                <Row>
                    <Col xs={12} sm={6}>
                        <SelectField
                            label="Typ pohybu"
                            value={filters.type ?? ''}
                            onChange={(value) => set('type', (value || undefined) as TransactionFilters['type'])}
                            options={[
                                { value: '', label: 'Vše' },
                                { value: 'EXPENSE', label: 'Útraty' },
                                { value: 'TRANSFER', label: 'Úhrady dluhů' },
                            ]}
                        />
                    </Col>
                    <Col xs={12} sm={6}>
                        <SelectField
                            label="Osoba"
                            value={filters.memberId ?? ''}
                            onChange={(value) => set('memberId', value || undefined)}
                            options={[
                                { value: '', label: 'Kdokoli' },
                                ...group.members.map((member) => ({ value: member.id, label: member.displayName })),
                            ]}
                        />
                    </Col>
                    {group.currencyCodes.length > 1 && (
                        <Col xs={12} sm={6}>
                            <SelectField
                                label="Měna"
                                value={filters.currencyCode ?? ''}
                                onChange={(value) => set('currencyCode', value || undefined)}
                                options={[{ value: '', label: 'Všechny' }, ...group.currencyCodes.map((code) => ({ value: code, label: code }))]}
                            />
                        </Col>
                    )}
                    <Col xs={6} sm={3}>
                        <TextField label="Od" type="date" value={filters.from ?? ''} onChange={(value) => set('from', value || undefined)} />
                    </Col>
                    <Col xs={6} sm={3}>
                        <TextField label="Do" type="date" value={filters.to ?? ''} onChange={(value) => set('to', value || undefined)} />
                    </Col>
                    <Col xs={12} sm={6}>
                        <TextField
                            label="Hledat v názvu"
                            value={filters.search ?? ''}
                            onChange={(value) => set('search', value || undefined)}
                            placeholder="Např. oběd"
                        />
                    </Col>
                    <Col xs={7} sm={4}>
                        <SelectField
                            label="Řadit podle"
                            value={filters.sort ?? 'occurredAt'}
                            onChange={(value) => set('sort', value as TransactionFilters['sort'])}
                            options={[
                                { value: 'occurredAt', label: 'Data' },
                                { value: 'amount', label: 'Částky' },
                                { value: 'title', label: 'Názvu' },
                            ]}
                        />
                    </Col>
                    <Col xs={5} sm={2}>
                        <SelectField
                            label="Pořadí"
                            value={filters.order ?? 'desc'}
                            onChange={(value) => set('order', value as TransactionFilters['order'])}
                            options={[
                                { value: 'desc', label: 'Sestupně' },
                                { value: 'asc', label: 'Vzestupně' },
                            ]}
                        />
                    </Col>
                </Row>

                <Button variant="outline-secondary" size="sm" className="su-tappable" onClick={onReset}>
                    Zrušit filtr
                </Button>
            </Card.Body>
        </Card>
    )
}
